var React = require('react');

function IconMenuTwo (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"HOME-(+menu)","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"home","transform":"translate(-1310.000000, -62.000000)","fill":"#000000"},React.createElement("g",{"id":"nav","transform":"translate(-37.000000, -5.000000)"},React.createElement("g",{"id":"menu","transform":"translate(1347.000000, 67.000000)"},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"59","height":"4","rx":"2","key":0}),React.createElement("rect",{"id":"Rectangle-Copy","x":"0","y":"10","width":"59","height":"4","rx":"2","key":1}),React.createElement("rect",{"id":"Rectangle-Copy-2","x":"0","y":"20","width":"59","height":"4","rx":"2","key":2})])))));
}

IconMenuTwo.defaultProps = {"width":"59px","height":"24px","viewBox":"0 0 59 24","version":"1.1"};

module.exports = IconMenuTwo;

IconMenuTwo.default = IconMenuTwo;
